import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueRouter from 'vue-router';
import VueI18Next from '@panter/vue-i18next';

export function initInstall (App) {
  App.install = function () {
    // Vue, by default, produces a warning that you're not in production. It's distracting, so, turn it off.
    Vue.config.productionTip = false;

    Vue.use(BootstrapVue);
    Vue.use(VueRouter);
    Vue.use(VueI18Next);
  };
}
